<script lang="ts">
	import { browser } from '$app/environment';
	import { createLazyLoadAttachment } from '$lib/attachments/lazyLoad';
	import FullPlaceDetails from '$lib/components/city/feature/FullPlaceDetails.svelte';
	import type { TypeMapPoints } from '$lib/components/ui/map/_other/typePoints';
	import Videos from '$lib/components/ui/Videos.svelte';
	import type { VideoDetails } from '$lib/features/_other/videoDetails.type';
	import { type SimplePlace } from '$lib/features/place/place.type';
	import IconMapMarker from '~icons/mdi/map-marker';
	import IconPartyPopper from '~icons/mdi/party-popper';

	const {
		name,
		place,
		videos = [],
		showMap = true,
		typeMapPoints
	}: {
		name: string;
		place: SimplePlace | undefined | null;
		videos?: VideoDetails[];
		showMap?: boolean;
		typeMapPoints?: TypeMapPoints;
	} = $props();

	let loadMap = $state<boolean>(false);

	const hasVideos = $derived<boolean>(videos.length > 0);
	const hasPlace = $derived<boolean>(place !== null && place !== undefined);

	const observeMapLoading = createLazyLoadAttachment(() => (loadMap = true));
</script>

<div>
	{#if hasVideos || (hasPlace && showMap)}
		<div class="w-full rounded-box border border-base-content/5 bg-base-300/50 p-4 md:p-4">
			<div class="grid grid-cols-1 gap-8 {hasVideos && hasPlace && showMap ? 'lg:grid-cols-2' : ''}">
				{#if hasPlace && showMap}
					<div class="flex flex-col gap-4">
						<h3 class="flex items-center gap-2 text-sm text-base-content/70">
							<IconMapMarker /> LOCATION
						</h3>

						<div {@attach observeMapLoading} class="relative h-[38vh] w-full overflow-hidden rounded-box bg-base-200 lg:h-56">
							{#if browser && loadMap}
								{#await import('$lib/components/ui/map/SinglePointMap.svelte') then { default: SinglePointMap }}
									<SinglePointMap primaryPoint={place!.coordinates} zoom={15} {typeMapPoints} />
								{/await}
							{:else}
								<div class="flex h-full w-full items-center justify-center bg-base-200 text-base-content/70">
									<span class="loading mr-2 loading-spinner text-primary"></span>
									<span>Loading map...</span>
								</div>
							{/if}
						</div>
					</div>
				{/if}

				{#if hasVideos}
					<div class="flex flex-col gap-4 overflow-hidden">
						<h3 class="flex items-center gap-2 text-sm text-base-content/70">
							<IconPartyPopper /> SEE IT IN ACTION
						</h3>
						<div class="w-full">
							<Videos {videos} englishName={name} />
						</div>
					</div>
				{/if}
			</div>
		</div>
	{/if}

	<FullPlaceDetails {place} classes="mt-6" />
</div>
